<header class="site-header" [ngClass]="{ 'site-header--scrolled': isScrolled || isMobileMenuOpen }">
  <nav class="site-header__nav" aria-label="Main Navigation">
    <div class="site-header__inner">
      <a class="site-brand" aria-label="Rêve Home" routerLink="/" (click)="onNavigationLinkClick('/')">
        <span class="site-brand__text">Rêve</span>
      </a>

      <div class="site-menu site-menu--desktop">
        <a class="site-menu__link" routerLink="/" [class.site-menu__link--active]="isActive('/')"
          [attr.aria-current]="isActive('/') ? 'page' : null" (click)="onNavigationLinkClick('/')">Home</a>
        <a class="site-menu__link" routerLink="/services" [class.site-menu__link--active]="isActive('/services')"
          [attr.aria-current]="isActive('/services') ? 'page' : null"
          (click)="onNavigationLinkClick('/services')">Capabilities</a>
        <a class="site-menu__link" routerLink="/about-us" [class.site-menu__link--active]="isActive('/about-us')"
          [attr.aria-current]="isActive('/about-us') ? 'page' : null"
          (click)="onNavigationLinkClick('/about-us')">Intelligence</a>
        <a class="site-menu__link" routerLink="/plans" [class.site-menu__link--active]="isActive('/plans')"
          [attr.aria-current]="isActive('/plans') ? 'page' : null" (click)="onNavigationLinkClick('/plans')">Plans</a>
        <a class="site-menu__link" routerLink="/dynamics-365"
          [class.site-menu__link--active]="isActive('/dynamics-365')"
          [attr.aria-current]="isActive('/dynamics-365') ? 'page' : null"
          (click)="onNavigationLinkClick('/dynamics-365')">Dynamics 365</a>
        <a class="site-menu__link" routerLink="/case-study" [class.site-menu__link--active]="isActive('/case-study')"
          [attr.aria-current]="isActive('/case-study') ? 'page' : null"
          (click)="onNavigationLinkClick('/case-study')">Case Studies</a>
        <a class="site-menu__link" routerLink="/partner-program"
          [class.site-menu__link--active]="isActive('/partner-program')"
          [attr.aria-current]="isActive('/partner-program') ? 'page' : null"
          (click)="onNavigationLinkClick('/partner-program')">Partners</a>
        <a class="site-menu__link" routerLink="/blog" [class.site-menu__link--active]="isActive('/blog')"
          [attr.aria-current]="isActive('/blog') ? 'page' : null" (click)="onNavigationLinkClick('/blog')">Blog</a>

        <span class="site-menu__divider" aria-hidden="true"></span>

        <button class="site-cta" type="button" aria-label="Contact Rêve for Consultation" (click)="openCalendlyPopup()">
          <span class="site-cta__text">Engage Us</span>
        </button>
      </div>

      <button class="site-menu-toggle" type="button" (click)="toggleMobileMenu()"
        [attr.aria-expanded]="isMobileMenuOpen" aria-label="Toggle navigation menu">
        @if (!isMobileMenuOpen) {
        <svg viewBox="0 0 24 24" aria-hidden="true">
          <path d="M4 8h16M4 16h16"></path>
        </svg>
        }
        @if (isMobileMenuOpen) {
        <svg viewBox="0 0 24 24" aria-hidden="true">
          <path d="M6 18L18 6M6 6l12 12"></path>
        </svg>
        }
      </button>
    </div>
  </nav>

  @if (isMobileMenuOpen) {
  <div class="site-mobile-menu">
    <div class="site-mobile-menu__inner">
      <a class="site-mobile-menu__link" routerLink="/" (click)="onNavigationLinkClick('/')">Home</a>
      <a class="site-mobile-menu__link" routerLink="/services" (click)="onNavigationLinkClick('/services')">Capabilities</a>
      <a class="site-mobile-menu__link" routerLink="/about-us" (click)="onNavigationLinkClick('/about-us')">Intelligence</a>
      <a class="site-mobile-menu__link" routerLink="/plans" (click)="onNavigationLinkClick('/plans')">Plans</a>
      <a class="site-mobile-menu__link" routerLink="/dynamics-365" (click)="onNavigationLinkClick('/dynamics-365')">Dynamics 365</a>
      <a class="site-mobile-menu__link" routerLink="/case-study" (click)="onNavigationLinkClick('/case-study')">Case Studies</a>
      <a class="site-mobile-menu__link" routerLink="/partner-program" (click)="onNavigationLinkClick('/partner-program')">Partners</a>
      <a class="site-mobile-menu__link" routerLink="/blog" (click)="onNavigationLinkClick('/blog')">Blog</a>
      <a class="site-mobile-menu__link" routerLink="/faq" (click)="onNavigationLinkClick('/faq')">FAQ</a>
      <div class="site-mobile-menu__footer">
        <hr class="site-mobile-menu__rule" aria-hidden="true" />
        <button class="site-mobile-menu__cta" type="button" aria-label="Contact Rêve for Consultation" (click)="openCalendlyPopup()">
          Engage Us
        </button>
      </div>
    </div>
  </div>
  }
</header>
